import TagManager from 'react-gtm-module';

type EventProps = {
  event: string;
  category?: string;
  action?: string;
  label?: string;
  value?: string;
};

const track = (event: EventProps): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Tracked Event:', JSON.parse(JSON.stringify(event)));
    return;
  }
  TagManager.dataLayer({
    dataLayer: event,
  });
};

export { track };
